import _ from 'lodash'
import { BotConfiguration } from '@feedyou/schema'
import { generalSettingsSchema } from './generalSettingsSchema'

export function getPatchFromFormData(formData: Partial<BotConfiguration>) {
  const stringKeys = Object.keys(
    _.pickBy(generalSettingsSchema.properties, prop => prop.type === 'string')
  )

  return _.mapValues(formData, (val, key) =>
    stringKeys.includes(key) && val === undefined ? '' : val
  ) as Partial<BotConfiguration>
}
